import React, { createContext, useContext, useState, useEffect } from 'react';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { CircularProgress } from '@mui/material';

// Create Context
const AppContext = createContext();

// Custom hook for consuming AppContext
export const useAdmin = () => useContext(AppContext);

// Provider Component
export const AppProvider = ({ children }) => {
    const [adminProfile, setAdminProfile] = useState(null);
    const [docId, setDocId] = useState(null);
    const [loading, setLoading] = useState(true); // New loading state

    useEffect(() => {
        const fetchAdminProfile = async () => {
            try {
                const db = getFirestore();
                const querySnapshot = await getDocs(collection(db, 'admin_profiles'));
                if (!querySnapshot.empty) {
                    const doc = querySnapshot.docs[0];
                    setAdminProfile(doc.data());
                    setDocId(doc.id); // Save the document ID for updates if needed
                } else {
                    console.error("Admin profile not found.");
                }
            } catch (error) {
                console.error("Error fetching admin profile:", error);
            } finally {
                setLoading(false); // Set loading to false after data fetch is complete
            }
        };

        fetchAdminProfile();
    }, []);

    return (
        <AppContext.Provider value={{ adminProfile, docId }}>
            {loading ? (
                <div style={{
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100vh'
                }}>
                    <CircularProgress  sx={{ color: 'primary' }} />
                </div>
            ) : (
                children
            )}
        </AppContext.Provider>
    );
};
